import React from 'react';
import './ZelleReport.css';
import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import {
  employeesSelector,
  userInfoSelector,
} from '../../../redux/selectors/auth';
import {
  allSessionIdsSelector,
  loadingSelector,
} from '../../../redux/selectors/settings';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  zelleHistorySelector,
  zelleTableSelector,
  zelleTotalBalanceSelector,
} from '../../../redux/selectors/loan';

import {
  CardContent,
  Typography,
  IconButton,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
  Dialog,
  Tooltip,
  Badge,
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getEmployees } from '../../../redux/actions/auth';
import { listZelleLoan, saveZelleLoan } from '../../../redux/actions/loan';
import { listAllCustomers } from '../../../redux/actions/customer';
import { customersSelector } from '../../../redux/selectors/customer';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  // v4 Chip, as the Weekly Report's filter chip — color="primary" there is
  // the app theme's navy, where the v5 one would be MUI's default blue
  Chip,
} from '@material-ui/core';
import FilterIcon from '../../global/FilterIcon';
import { listSessionIds } from '../../../redux/actions/settings';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BACK } from '../../customer/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { GetApp } from '@material-ui/icons';
import Utils from '../../Utils/Utils';
import WriteGuard from '../../global/ReadOnly/WriteGuard';

class ZelleReport extends React.Component {
  constructor(props) {
    super(props);

    const todayHouston = this.getHoustonToday();
    const currentDay = todayHouston.getDay();

    // Distance to last Tuesday
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);

    const fromDate = new Date(todayHouston);
    fromDate.setDate(todayHouston.getDate() - diffToLastTuesday);

    const toDate = new Date(fromDate);
    toDate.setDate(fromDate.getDate() + 6);

    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      selectedEmployeeId: null,
      selectedCustomerName: null,
      amountInput: '',
      dateInput: new Date().toISOString().split('T')[0],
      zelleHistory: {},
      displayOrder: [],
      expanded: {},
      selectedType: null,
      isDialogOpen: false,
      fromDate,
      toDate,
      // The week the loaded data is for. fromDate/toDate move as the user
      // picks in the filter dialog; these only move on Apply / Reset, and
      // drive the "filter active" badge.
      appliedFromDate: fromDate,
      appliedToDate: toDate,
      viewingReportFor: null,
    };
    this.colorMap = {};
  }

  componentDidMount() {
    this.props.listAllCustomers({
      locationId: this.props.userInfo.selectedLocationId,
    });

    this.props.getEmployees({
      locationId: this.props.userInfo.selectedLocationId,
    });

    this.props.listSessionIds(
      this.getChicagoDateFromDate(this.state.fromDate),
      this.getChicagoDateFromDate(this.state.toDate),
      this.props.userInfo.selectedLocationId
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.zelleHistory !== this.props.zelleHistory) {
      const zelleHistoryObj = {};

      this.props.zelleHistory.forEach((loan) => {
        const empId = loan.employeeLoanId;

        if (!zelleHistoryObj[empId]) {
          zelleHistoryObj[empId] = [];
        }

        zelleHistoryObj[empId] = [
          ...zelleHistoryObj[empId],
          ...(loan.zelleHistory || []).map((entry) => ({
            ...entry,
            transactionId: entry.transactionId || null,
          })),
        ];
      });
      this.setState({ zelleHistory: zelleHistoryObj });
    }

    if (prevProps.allSessionIds !== this.props.allSessionIds) {
      this.setState({ selectedSessionIds: this.props.allSessionIds }, () => {
        this.props.listZelleLoan({
          locationId: this.props.userInfo.selectedLocationId,
          userId: this.props.userInfo.userId,
          sessionIds: this.props.allSessionIds,
        });
      });
    }
  }

  // -$1,234.00 rather than $-1,234.00
  formatBalance = (value) =>
    `${value < 0 ? '-' : ''}$${Math.abs(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  handleDownloadConsolidatedPDF = () => {
    if (this.props.loadingData) {
      this.openFeedbackBar('error', 'Please wait, data is still loading...');
      return;
    }

    if (!this.props.zelleHistory || this.props.zelleHistory.length === 0) {
      this.openFeedbackBar('error', 'No data available to download.');
      return;
    }

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const { zelleHistory, fromDate, toDate } = this.state;

    const fromStr = this.getChicagoDateFromDate(fromDate);
    const toStr = this.getChicagoDateFromDate(toDate);

    // ── Page header ──────────────────────────────────────────────────
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(33, 37, 41);
    doc.text('Weekly Consolidated Zelle Report', pageWidth / 2, 14, {
      align: 'center',
    });

    doc.setFontSize(9);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(120, 120, 120);
    doc.text(`Period: ${fromStr} – ${toStr}`, pageWidth / 2, 20, {
      align: 'center',
    });

    let currentY = 26;

    // ── Per-employee detail ───────────────────────────────────────────
    const orderedEmployees =
      this.state.displayOrder.length > 0
        ? this.state.displayOrder
        : this.props.employees.map((c) => c.userId);

    let isFirstEmployee = true;
    const summaryRows = [];

    orderedEmployees.forEach((userId) => {
      const employee = this.props.employees.find((c) => c.userId === userId);
      if (!employee) return;

      const history = [...(zelleHistory[userId] || [])].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      if (history.length === 0) return;

      if (!isFirstEmployee) {
        currentY += 8; // small gap between employees, no forced new page
      }
      isFirstEmployee = false;

      doc.setFontSize(11);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(33, 37, 41);
      doc.text(
        `${employee.firstname} ${employee.lastname || ''}`,
        14,
        currentY
      );
      currentY += 4;

      let runningBalance = 0;
      const tableRows = history.map((row) => {
        runningBalance += row.amount;
        const day = new Date(row.date.replace(/-/g, '/')).toLocaleDateString(
          'en-US',
          {
            weekday: 'long',
            timeZone: 'America/Chicago',
          }
        );
        return [
          row.date,
          day,
          row.customerName || 'N/A',
          row.employeeName || '',
          row.amount < 0
            ? `-$${Math.abs(row.amount).toLocaleString()}`
            : `+$${row.amount.toLocaleString()}`,
          this.formatBalance(runningBalance),
        ];
      });

      autoTable(doc, {
        startY: currentY,
        head: [['Date', 'Day', 'Client', 'Employee', 'Amount', 'Balance']],
        body: tableRows,
        theme: 'grid',
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: [33, 37, 41],
          fontStyle: 'bold',
          fontSize: 8,
          halign: 'center',
        },
        styles: { fontSize: 7, cellPadding: 2, textColor: [33, 37, 41] },
        columnStyles: {
          4: { halign: 'right', fontStyle: 'bold' },
          5: { halign: 'right', fontStyle: 'bold' },
        },
        didParseCell: (data) => {
          if (data.section === 'body') {
            const rowData = history[data.row.index];
            if (rowData.amount < 0) {
              data.cell.styles.fillColor = [255, 235, 235];
              data.cell.styles.textColor = [153, 0, 0];
            } else {
              data.cell.styles.fillColor = [232, 245, 233];
              data.cell.styles.textColor = [0, 97, 0];
            }
          }
        },
      });

      const finalY = doc.lastAutoTable.finalY + 4;
      doc.setFillColor(240, 240, 240);
      doc.rect(14, finalY, pageWidth - 28, 7, 'F');
      doc.setFontSize(8);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(33, 37, 41);
      doc.text('Total Balance', 18, finalY + 5);
      doc.text(
        this.formatBalance(this.getEmployeeBalance(userId)),
        pageWidth - 18,
        finalY + 5,
        { align: 'right' }
      );

      currentY = finalY + 12;

      summaryRows.push({
        name: `${employee.firstname} ${employee.lastname || ''}`.trim(),
        entries: history.length,
        total: this.getEmployeeBalance(userId),
      });
    });

    // ── Summary: total for all employees, then each employee ─────────
    if (summaryRows.length > 0) {
      const grandTotal = summaryRows.reduce((acc, r) => acc + r.total, 0);
      const totalEntries = summaryRows.reduce((acc, r) => acc + r.entries, 0);

      // Keep the heading, grand total and the first rows together
      const pageHeight = doc.internal.pageSize.getHeight();
      if (currentY + 45 > pageHeight - 14) {
        doc.addPage();
        currentY = 20;
      } else {
        currentY += 4;
      }

      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(33, 37, 41);
      doc.text('Summary', 14, currentY);
      currentY += 4;

      doc.setFillColor(33, 37, 41);
      doc.rect(14, currentY, pageWidth - 28, 9, 'F');
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.text(
        `Total — All Employees (${totalEntries} entries)`,
        18,
        currentY + 6
      );
      doc.text(this.formatBalance(grandTotal), pageWidth - 18, currentY + 6, {
        align: 'right',
      });
      currentY += 13;

      autoTable(doc, {
        startY: currentY,
        head: [['Employee', 'Entries', 'Total']],
        body: summaryRows.map((r) => [
          r.name,
          r.entries,
          this.formatBalance(r.total),
        ]),
        theme: 'grid',
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: [33, 37, 41],
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'center',
        },
        styles: { fontSize: 9, cellPadding: 2.5, textColor: [33, 37, 41] },
        columnStyles: {
          1: { halign: 'center' },
          2: { halign: 'right', fontStyle: 'bold' },
        },
        didParseCell: (data) => {
          if (data.section === 'body' && data.column.index === 2) {
            data.cell.styles.textColor =
              summaryRows[data.row.index].total < 0 ? [153, 0, 0] : [0, 97, 0];
          }
        },
      });
    }

    const pdfData = doc.output('arraybuffer');

    Utils.handlePdfAction(
      pdfData,
      'download',
      `Zelle_Weekly_Consolidated_${fromStr}_to_${toStr}.pdf`
    );
  };

  handleDownloadPDF = (employee) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // Sort oldest → newest
    const history = [...(this.state.zelleHistory[employee.userId] || [])].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    // =============================
    // 1. SIMPLE HEADER (LEFT ALIGNED)
    // =============================
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(33, 37, 41);
    doc.text(`${employee.firstname} ${employee.lastname || ''}`, 14, 20);

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(120, 120, 120);

    // =============================
    // 2. TABLE DATA
    // =============================
    let runningBalance = 0;

    const tableRows = history.map((row) => {
      runningBalance += row.amount;

      const day = new Date(row.date.replace(/-/g, '/')).toLocaleDateString(
        'en-US',
        {
          weekday: 'long',
          timeZone: 'America/Chicago', // Explicitly set the timezone
        }
      );

      return [
        row.date,
        day,
        row.customerName || 'N/A',
        row.employeeName || '',
        row.amount < 0
          ? `-$${Math.abs(row.amount).toLocaleString()}`
          : `+$${row.amount.toLocaleString()}`,
        this.formatBalance(runningBalance),
      ];
    });

    // =============================
    // 3. TABLE DESIGN
    // =============================
    autoTable(doc, {
      startY: 26,
      head: [['Date', 'Day', 'Client', 'Employee', 'Amount', 'Balance']],
      body: tableRows,
      theme: 'grid',

      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [33, 37, 41],
        fontStyle: 'bold',
        fontSize: 11,
        halign: 'center',
      },

      styles: {
        fontSize: 9,
        cellPadding: 5,
        textColor: [33, 37, 41],
      },

      columnStyles: {
        4: { halign: 'right', fontStyle: 'bold' },
        5: { halign: 'right', fontStyle: 'bold' },
      },

      didParseCell: (data) => {
        if (data.section === 'body') {
          const rowData = history[data.row.index];

          if (rowData.amount < 0) {
            // Light Professional Red Row
            data.cell.styles.fillColor = [255, 235, 235];
            data.cell.styles.textColor = [153, 0, 0];
          } else {
            // Light Professional Green Row
            data.cell.styles.fillColor = [232, 245, 233];
            data.cell.styles.textColor = [0, 97, 0];
          }
        }
      },
    });

    // =============================
    // 4. TOTAL SECTION
    // =============================
    const finalY = doc.lastAutoTable.finalY + 8;

    doc.setFillColor(240, 240, 240);
    doc.rect(14, finalY, pageWidth - 28, 12, 'F');

    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(33, 37, 41);

    doc.text('Total Balance', 20, finalY + 8);

    doc.text(
      this.formatBalance(this.getEmployeeBalance(employee.userId)),
      pageWidth - 20,
      finalY + 8,
      { align: 'right' }
    );

    // =============================
    // 5. OUTPUT
    // =============================
    const pdfData = doc.output('arraybuffer');

    Utils.handlePdfAction(
      pdfData,
      'download',
      `Zelle_Report_${employee.firstname}.pdf`
    );
  };

  toggleExpand = (custId) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,
        [custId]: !prev.expanded[custId],
      },
    }));
  };

  getColorForEmployee(custId) {
    if (!this.colorMap[custId]) {
      this.colorMap[custId] = this.getRandomLightColor();
    }
    return this.colorMap[custId];
  }

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  handleEmployeeChange = (event, newValue) => {
    this.setState({
      selectedEmployeeId: newValue ? newValue.userId : null,
    });
  };

  handleDateChange = (date) => {
    if (date && date.toString() !== 'Invalid Date') {
      // format to yyyy-MM-dd string for your existing code logic (optional)
      const formattedDate = date.toISOString().split('T')[0];
      this.setState({ dateInput: formattedDate });
    } else {
      this.setState({ dateInput: '' });
    }
  };

  handleAddTransaction = () => {
    const {
      amountInput,
      dateInput,
      selectedEmployeeId,
      selectedCustomerName,
      zelleHistory,
      selectedType,
    } = this.state;

    if (!selectedEmployeeId) {
      this.openFeedbackBar('error', 'Please select an employee');
      return;
    }

    if (!selectedType) {
      this.openFeedbackBar('error', 'Please select a type');
      return;
    }

    if (!amountInput || isNaN(amountInput) || parseFloat(amountInput) <= 0) {
      this.openFeedbackBar(
        'error',
        'Please enter a valid amount greater than 0'
      );
      return;
    }

    if (!dateInput) {
      this.openFeedbackBar('error', 'Please select a date');
      return;
    }

    const employee = this.props.employees.find(
      (c) => c.userId === selectedEmployeeId
    );

    // Prepare the new transaction
    let amount = parseFloat(amountInput);
    if (selectedType.toUpperCase() === 'SUBTRACT') {
      amount = -amount; // match Grails logic
    }

    const newTransaction = {
      firstName: employee.firstname,
      lastName: employee.lastname,
      amount,
      date: dateInput,
      type: selectedType,
      customerName: selectedCustomerName,
      employeeName: this.props.userInfo?.firstname,
    };

    // Add new transaction to zelleHistory
    const updatedHistory = {
      ...zelleHistory,
      [selectedEmployeeId]: [
        newTransaction,
        ...(zelleHistory[selectedEmployeeId] || []),
      ],
    };

    // Build new display order
    const allEmployeeIds = this.props.employees.map((c) => c.userId);
    const newDisplayOrder = [
      selectedEmployeeId,
      ...allEmployeeIds.filter((id) => id !== selectedEmployeeId),
    ];

    // Call backend with updatedHistory
    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', error);
      } else {
        this.setState({
          zelleHistory: updatedHistory,
          displayOrder: newDisplayOrder,
          amountInput: '',
          dateInput: new Date().toISOString().split('T')[0],
          selectedEmployeeId: null,
          selectedCustomerName: null,
          selectedType: null,
        });

        this.openFeedbackBar('success', response);
      }
    };

    const currentSessionId =
      Array.isArray(this.state.selectedSessionIds) &&
      this.state.selectedSessionIds.length > 0
        ? this.state.selectedSessionIds[
            this.state.selectedSessionIds.length - 1
          ] // pick latest
        : null;

    if (!currentSessionId) {
      this.openFeedbackBar('error', 'No session found for this week.');
      return;
    }

    this.props.saveZelleLoan(
      {
        zelleHistory: {
          [selectedEmployeeId]: [newTransaction],
        },
        locationId: this.props.userInfo.selectedLocationId,
        sessionId: currentSessionId,
      },
      callback
    );
  };

  getEmployeeBalance = (employeeId) => {
    const history = this.state.zelleHistory[employeeId] || [];
    return history.reduce((acc, t) => acc + t.amount, 0);
  };

  getRandomLightColor() {
    const r = Math.floor(Math.random() * 25) + 230; // 230-255
    const g = Math.floor(Math.random() * 25) + 230;
    const b = Math.floor(Math.random() * 25) + 230;
    return `rgb(${r}, ${g}, ${b})`;
  }

  handleCustomerChange = (event, newValue) => {
    // newValue is the selected customer object or null
    this.setState({
      selectedCustomerName: newValue
        ? `${newValue.firstName} ${newValue.lastName}`
        : null,
    });
  };

  userIsAnAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MASTER_ADMIN');
  };

  //filter

  getHoustonToday() {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(new Date());

    let year, month, day;
    parts.forEach((p) => {
      if (p.type === 'year') year = p.value;
      if (p.type === 'month') month = p.value;
      if (p.type === 'day') day = p.value;
    });

    // Create a Date that represents midnight Houston time
    return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
  }

  getChicagoDateFromDate(date) {
    // Get the Chicago date parts
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(date);
    let year, month, day;

    for (const part of parts) {
      switch (part.type) {
        case 'year':
          year = part.value;
          break;
        case 'month':
          month = part.value;
          break;
        case 'day':
          day = part.value;
          break;
        default:
          break;
      }
    }

    return `${year}-${month}-${day}`;
  }

  applyDateRange = () => {
    const { fromDate, toDate } = this.state;
    const fromDateInChicago = this.getChicagoDateFromDate(fromDate);
    const toDateInChicago = this.getChicagoDateFromDate(toDate);

    this.props.listSessionIds(
      fromDateInChicago,
      toDateInChicago,
      this.props.userInfo.selectedLocationId
    );

    this.setState({
      isDialogOpen: false,
      appliedFromDate: fromDate,
      appliedToDate: toDate,
    });
  };

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  // Cancel drops any un-applied pick so the pickers, PDFs and badge keep
  // matching the week that is actually loaded.
  handleDialogClose = () => {
    this.setState((prev) => ({
      isDialogOpen: false,
      fromDate: prev.appliedFromDate,
      toDate: prev.appliedToDate,
    }));
  };

  // Stored Tue -> Mon pair for the current reading week (Chicago)
  getCurrentWeekRange() {
    const todayHouston = this.getHoustonToday();
    const currentDay = todayHouston.getDay();
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);

    const fromDate = new Date(todayHouston);
    fromDate.setDate(todayHouston.getDate() - diffToLastTuesday);
    const toDate = new Date(fromDate);
    toDate.setDate(fromDate.getDate() + 6);
    return { fromDate, toDate };
  }

  // A week other than the current one is loaded
  isWeekFilterActive = () => {
    const { appliedFromDate } = this.state;
    if (!appliedFromDate) return false;
    return (
      appliedFromDate.toDateString() !==
      this.getCurrentWeekRange().fromDate.toDateString()
    );
  };

  // Badge label, in the Mon -> Sun display space the filter uses
  getWeekFilterLabel = () => {
    const { appliedFromDate, appliedToDate } = this.state;
    const fmt = (d, withYear) =>
      this.toDisplayDate(d).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        ...(withYear ? { year: 'numeric' } : {}),
      });
    return `Week: ${fmt(appliedFromDate)} – ${fmt(appliedToDate, true)}`;
  };

  resetWeekFilter = () => {
    const { fromDate, toDate } = this.getCurrentWeekRange();
    this.setState({ fromDate, toDate }, this.applyDateRange);
  };

  // Get the Monday that closes the reading week opened by the given Tuesday
  getMondayFromTuesday = (tuesdayDate) => {
    const monday = new Date(tuesdayDate);
    monday.setDate(tuesdayDate.getDate() + 6);
    return monday;
  };

  // ── Filter display shift: stored week vs shown week ──
  //
  // Same as the Weekly Report (ReportView): the reading week the backend
  // stores runs TUESDAY -> MONDAY, and that is what applyDateRange sends.
  // Operators read their week as MONDAY -> SUNDAY, so the filter dialog
  // renders the range shifted back one day and shifts the user's pick
  // forward again before it touches state.
  //
  // The shift lives ONLY in the two pickers. state.fromDate / state.toDate
  // remain the real Tue/Mon pair everywhere else — the fetch and the PDFs.
  static DISPLAY_OFFSET_DAYS = -1;

  // Stored (Tue/Mon) -> shown (Mon/Sun)
  toDisplayDate = (date) =>
    this.shiftDays(date, ZelleReport.DISPLAY_OFFSET_DAYS);

  // Shown (Mon/Sun) -> stored (Tue/Mon)
  fromDisplayDate = (date) =>
    this.shiftDays(date, -ZelleReport.DISPLAY_OFFSET_DAYS);

  shiftDays = (date, days) => {
    if (!date) return null;
    const shifted = new Date(date);
    shifted.setDate(date.getDate() + days);
    return shifted;
  };

  // What the From picker may land on, in DISPLAY space
  isMonday = (date) => date.getDay() === 1;

  // Handle 'fromDate' — the user picks the displayed Monday; state keeps the
  // Tuesday it stands for.
  handleFromDateChange = (displayDate) => {
    if (!displayDate || !this.isMonday(displayDate)) return;

    const date = this.fromDisplayDate(displayDate);
    const toDate = this.getMondayFromTuesday(date);
    this.setState({
      fromDate: date,
      toDate,
    });
  };

  // Handle 'toDate' — the user picks the displayed Sunday, which must be the
  // one that closes the week fromDate opened.
  handleToDateChange = (displayDate) => {
    if (!displayDate) return;

    const { fromDate } = this.state;
    if (!fromDate) return;

    const validSunday = this.toDisplayDate(this.getMondayFromTuesday(fromDate));
    if (displayDate.toDateString() !== validSunday.toDateString()) return;

    this.setState({ toDate: this.fromDisplayDate(displayDate) });
  };

  renderSummaryTable = () => {
    const { zelleTable } = this.props;

    if (!zelleTable || zelleTable.length === 0) return null;

    const boldStyle = { fontWeight: 600 };

    const formatAmount = (amount) => {
      return amount && amount !== 0 ? `$${amount.toLocaleString()}` : '';
    };

    // ✅ Calculate totals by each day
    const dayTotals = zelleTable.reduce(
      (acc, row) => {
        acc.monday += row.monday || 0;
        acc.tuesday += row.tuesday || 0;
        acc.wednesday += row.wednesday || 0;
        acc.thursday += row.thursday || 0;
        acc.friday += row.friday || 0;
        acc.saturday += row.saturday || 0;
        acc.sunday += row.sunday || 0;
        return acc;
      },
      {
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0,
      }
    );

    // ✅ Total of all days
    const grandTotal =
      dayTotals.monday +
      dayTotals.tuesday +
      dayTotals.wednesday +
      dayTotals.thursday +
      dayTotals.friday +
      dayTotals.saturday +
      dayTotals.sunday;

    return (
      <div className="summary-zelle-container">
        <table className="summary-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {zelleTable.map((row, index) => {
              const total =
                (row.monday || 0) +
                (row.tuesday || 0) +
                (row.wednesday || 0) +
                (row.thursday || 0) +
                (row.friday || 0) +
                (row.saturday || 0) +
                (row.sunday || 0);

              return (
                <tr key={index}>
                  <td style={boldStyle}>{row.employee}</td>
                  <td>{formatAmount(row.monday)}</td>
                  <td>{formatAmount(row.tuesday)}</td>
                  <td>{formatAmount(row.wednesday)}</td>
                  <td>{formatAmount(row.thursday)}</td>
                  <td>{formatAmount(row.friday)}</td>
                  <td>{formatAmount(row.saturday)}</td>
                  <td>{formatAmount(row.sunday)}</td>
                  <td style={boldStyle}>
                    {total !== 0 ? `$${total.toLocaleString()}` : ''}
                  </td>
                </tr>
              );
            })}

            {/* ✅ Daily Totals Row */}
            <tr style={{ fontWeight: '700', backgroundColor: '#f5f5f5' }}>
              <td>Total</td>
              <td>{formatAmount(dayTotals.monday)}</td>
              <td>{formatAmount(dayTotals.tuesday)}</td>
              <td>{formatAmount(dayTotals.wednesday)}</td>
              <td>{formatAmount(dayTotals.thursday)}</td>
              <td>{formatAmount(dayTotals.friday)}</td>
              <td>{formatAmount(dayTotals.saturday)}</td>
              <td>{formatAmount(dayTotals.sunday)}</td>
              <td>{formatAmount(grandTotal)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  renderDetailView(userId) {
    const employee = this.props.employees.find((c) => c.userId === userId);
    if (!employee) return null;

    const history = [...(this.state.zelleHistory[userId] || [])].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    let runningBalance = 0;
    const displayRows = history.map((t) => {
      runningBalance += t.amount;
      return { ...t, currentBalance: runningBalance };
    });

    return (
      <div className="report-detail-container loan-container">
        <div id="capture-report-area" className="report-pink-card">
          <div className="report-card-header">
            <Typography className="report-customer-name">
              {employee.firstname} {employee.lastname}
            </Typography>
          </div>

          <div className="table-responsive-wrapper">
            <table className="loan-report-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Day</th>
                  <th>Client</th>
                  <th>Employee</th>
                  <th>Amount</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {displayRows.map((row, index) => {
                  const day = new Date(
                    row.date.replace(/-/g, '/')
                  ).toLocaleDateString('en-US', {
                    weekday: 'long',
                    timeZone: 'America/Chicago', // Explicitly set the timezone
                  });
                  return (
                    <tr
                      key={index}
                      className={
                        row.amount < 0 ? 'bg-light-red' : 'bg-light-green'
                      }
                    >
                      <td className="date-cell">{row.date}</td>
                      <td className="day-cell">{day}</td>
                      <td className="client-cell">{row.customerName}</td>
                      <td className="employee-cell">{row.employeeName}</td>
                      <td
                        className={`amount-cell ${
                          row.amount < 0 ? 'text-red' : 'text-green'
                        }`}
                      >
                        {row.amount < 0
                          ? `- $${Math.abs(row.amount).toLocaleString()}`
                          : `+ $${row.amount.toLocaleString()}`}
                      </td>
                      <td className="balance-cell">
                        {this.formatBalance(row.currentBalance)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="report-card-footer">
            <Typography className="footer-label">Total Balance:</Typography>
            <Typography className="footer-amount">
              {this.formatBalance(this.getEmployeeBalance(userId))}
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      dateInput,
      displayOrder,
      zelleHistory,
      selectedCustomerName,
      fromDate,
      toDate,
      viewingReportFor,
    } = this.state;

    // The filter renders the week shifted back one day (Mon -> Sun) while
    // state keeps the stored Tue -> Mon pair. See the display-shift block by
    // handleFromDateChange.
    const displayFromDate = this.toDisplayDate(fromDate);
    const displayToDate = this.toDisplayDate(toDate);
    const validSunday = fromDate
      ? this.toDisplayDate(this.getMondayFromTuesday(fromDate))
      : null;

    const orderedEmployees =
      displayOrder.length > 0
        ? displayOrder
        : this.props.employees.map((c) => c.userId);

    const currentViewEmployee = viewingReportFor
      ? this.props.employees.find((c) => c.userId === viewingReportFor)
      : null;

    const hasData =
      this.props.zelleHistory && this.props.zelleHistory.length > 0;

    const menuItems = viewingReportFor
      ? [
          {
            title: BACK,
            icon: <KeyboardBackspaceIcon />,
            onClick: () => this.setState({ viewingReportFor: null }),
          },
          {
            title: 'Download',
            icon: <GetApp />,
            onClick: () => this.handleDownloadPDF(currentViewEmployee),
          },
        ]
      : [
          {
            title: 'Download Weekly Consolidated Report',
            icon: <GetApp />,
            onClick: hasData ? this.handleDownloadConsolidatedPDF : null,
            disabled: !hasData,
          },
        ];

    return (
      <React.Fragment>
        <TopToolbar
          pageName={viewingReportFor ? 'Zelle Report' : 'Zelle Report List'}
          menuItems={menuItems}
        />

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {viewingReportFor ? (
          this.renderDetailView(viewingReportFor)
        ) : (
          <>
            {/* Week Filter Section */}

            <div
              className="zelle-filter-row"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0px',
                marginTop: '32px',
                marginLeft: '10px',
              }}
            >
              <IconButton
                className="filter-button"
                onClick={this.handleDialogOpen}
                size="small"
                aria-label="Filter"
              >
                <Badge
                  color="primary"
                  variant="dot"
                  invisible={!this.isWeekFilterActive()}
                  overlap="circular"
                >
                  <FilterIcon />
                </Badge>
              </IconButton>
              <h4 style={{ marginTop: '-7px' }}>Week Filter</h4>
              {this.isWeekFilterActive() && (
                <Chip
                  size="small"
                  color="primary"
                  label={this.getWeekFilterLabel()}
                  onClick={this.handleDialogOpen}
                  onDelete={this.resetWeekFilter}
                  title="Filter applied — click to change, x to go back to this week"
                  style={{ marginLeft: '12px', marginTop: '-7px' }}
                />
              )}
            </div>

            <Dialog
              open={this.state.isDialogOpen}
              onClose={this.handleDialogClose}
              aria-labelledby="date-range-dialog"
            >
              <DialogTitle id="date-range-dialog">Filters</DialogTitle>
              <DialogContent>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <div className="row-report">
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="From Date (Monday only)"
                      format="yyyy-MM-dd"
                      value={displayFromDate}
                      onChange={this.handleFromDateChange}
                      shouldDisableDate={(date) => !this.isMonday(date)}
                      disableMaskedInput
                    />

                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="To Date (Sunday only)"
                      format="yyyy-MM-dd"
                      value={displayToDate}
                      onChange={this.handleToDateChange}
                      shouldDisableDate={(date) => {
                        if (!validSunday) return true;
                        return (
                          date.toDateString() !== validSunday.toDateString()
                        );
                      }}
                      disableMaskedInput
                    />
                  </div>
                </MuiPickersUtilsProvider>
              </DialogContent>

              <DialogActions>
                <Button
                  variant="contained"
                  onClick={this.handleDialogClose}
                  style={{
                    width: '100px',
                    marginRight: '16px',
                    marginBottom: '16px',
                  }}
                >
                  Cancel
                </Button>

                <Button
                  autoFocus
                  variant="contained"
                  onClick={this.applyDateRange}
                  color="primary"
                  style={{
                    width: '100px',
                    marginRight: '16px',
                    marginBottom: '16px',
                  }}
                >
                  {' '}
                  Apply
                </Button>
              </DialogActions>
            </Dialog>

            <div className="zelle-container">
              {/* Add Transaction Form */}
              {/* Add-transaction form. Greyed and inert at a VIEW-ONLY
                  location — the report itself stays fully readable, only
                  recording a new entry is off.
                  See constants/readOnlyAccess.js. */}
              {this.userIsAnAdmin() && (
                <WriteGuard mode="disable" noTooltip>
                  <div className="zelle-form">
                    <div className="form-row">
                      <Autocomplete
                        className="form-input"
                        options={this.props.customers}
                        getOptionLabel={(option) =>
                          `${option.firstName} ${option.lastName}`
                        }
                        value={
                          selectedCustomerName
                            ? this.props.customers.find(
                                (c) =>
                                  `${c.firstName} ${c.lastName}` ===
                                  selectedCustomerName
                              ) || null
                            : null
                        }
                        onChange={this.handleCustomerChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="customer"
                            label="Select Customer"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        filterOptions={(options, { inputValue }) => {
                          return options.filter(
                            (c) =>
                              c.firstName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              c.lastName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                          );
                        }}
                        clearOnEscape
                      />

                      <Autocomplete
                        className="form-input"
                        options={
                          Array.isArray(this.props.employees)
                            ? this.props.employees
                            : [this.props.employees]
                        }
                        getOptionLabel={(option) =>
                          [option.firstname, option.lastname]
                            .filter(Boolean)
                            .join(' ')
                        } // ✅ filter(Boolean) removes undefined or empty
                        value={
                          this.state.selectedEmployeeId
                            ? this.props.employees.find(
                                (c) =>
                                  c.userId === this.state.selectedEmployeeId
                              ) || null
                            : null
                        }
                        onChange={this.handleEmployeeChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="employee"
                            label="Funds deposited to account of"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        filterOptions={(options, { inputValue }) => {
                          return options.filter((c) => {
                            const fullName = [c.firstname, c.lastname]
                              .filter(Boolean)
                              .join(' ')
                              .toLowerCase();
                            return fullName.includes(inputValue.toLowerCase());
                          });
                        }}
                        clearOnEscape
                      />

                      <Autocomplete
                        className="form-input"
                        options={['ADD', 'SUBTRACT']}
                        value={this.state.selectedType || null}
                        onChange={(event, newValue) => {
                          this.setState({ selectedType: newValue });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="type"
                            label="Select Type"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        clearOnEscape
                      />

                      <TextField
                        className="form-input"
                        variant="outlined"
                        label="Amount"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        name="amount"
                        required
                        value={this.state.amountInput}
                        onChange={(e) => {
                          // Only allow digits and optional decimal point
                          const value = e.target.value;
                          const sanitizedValue = value.replace(/[^0-9.]/g, '');
                          this.setState({ amountInput: sanitizedValue });
                        }}
                        type="text" // keep as text to fully control input
                        onBlur={() => {
                          let val = parseFloat(this.state.amountInput);
                          if (isNaN(val) || val < 0) val = 0;
                          this.setState({ amountInput: val.toFixed(2) });
                        }}
                      />

                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className="form-input"
                          autoOk
                          name="toDate"
                          variant="inline"
                          inputVariant="outlined"
                          label="Date"
                          format="yyyy-MM-dd"
                          required
                          InputAdornmentProps={{ position: 'start' }}
                          value={dateInput ? new Date(dateInput) : null}
                          onChange={this.handleDateChange}
                        />
                      </MuiPickersUtilsProvider>

                      <button
                        onClick={this.handleAddTransaction}
                        className="zelle-btn"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </WriteGuard>
              )}

              {/* All Employees Loan History */}
              {(!this.props.zelleHistory ||
                this.props.zelleHistory.length === 0) && (
                <div className="no-history-container">
                  <CardContent className="no-history-card">
                    <div className="no-history-icon">
                      <span role="img" aria-label="empty">
                        📄
                      </span>
                    </div>
                    <Typography variant="h6" className="no-history-title">
                      No Zelle Added Yet
                    </Typography>
                    <span className="no-history-subtitle">
                      Once you add a record, it will appear here.
                    </span>
                  </CardContent>
                </div>
              )}

              <div className="zelle-history-card-container">
                {orderedEmployees.map((userId) => {
                  const user = this.props.employees.find(
                    (c) => c.userId === userId
                  );
                  if (!user) return null;

                  const history = zelleHistory[userId] || [];
                  if (history.length === 0) return null;

                  const balance = this.getEmployeeBalance(userId);
                  const isExpanded = this.state.expanded[userId] || false;

                  return (
                    <div
                      key={userId}
                      className="note-card-zelle"
                      style={{
                        backgroundColor: this.getColorForEmployee(userId),
                      }}
                    >
                      {/* Employee Name */}
                      <CardContent className="">
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography variant="h6" className="customer-name">
                            {user.firstname} {user.lastname}
                          </Typography>

                          <div>
                            <Tooltip title="View Detailed Report">
                              <IconButton
                                onClick={() =>
                                  this.setState({ viewingReportFor: userId })
                                }
                                size="small"
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <IconButton
                              onClick={() => this.toggleExpand(userId)}
                              size="small"
                            >
                              {isExpanded ? (
                                <ExpandLessIcon />
                              ) : (
                                <ExpandMoreIcon />
                              )}
                            </IconButton>
                          </div>

                          {/*<IconButton*/}
                          {/*    onClick={() => this.toggleExpand(userId)}*/}
                          {/*    className="toggle-btn"*/}
                          {/*    size="small"*/}
                          {/*>*/}
                          {/*  {isExpanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}*/}
                          {/*</IconButton>*/}
                        </div>
                      </CardContent>

                      <Divider className="thin-divider" />

                      {/* Transactions List */}
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <CardContent className="transactions-list">
                          <List dense>
                            {history.map((t, i) => (
                              <ListItem key={i}>
                                <ListItemText
                                  primary={
                                    <span>
                                      <span
                                        style={{
                                          fontSize: '1.2em',
                                          color: t.amount < 0 ? 'red' : 'green',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {`${
                                          t.amount < 0 ? '-' : '+'
                                        }$${Math.abs(t.amount)}`}
                                      </span>{' '}
                                      <span
                                        style={{
                                          color: 'gray',
                                          fontSize: '0.85em',
                                        }}
                                      >
                                        ({t.customerName}) — {t.date} —{' '}
                                        <span style={{ fontStyle: 'italic' }}>
                                          {t.employeeName}
                                        </span>
                                      </span>
                                    </span>
                                  }
                                />
                              </ListItem>
                            ))}
                          </List>
                        </CardContent>
                      </Collapse>

                      {/* Balance */}
                      <CardContent className="balance-section">
                        <Typography
                          variant="h6"
                          style={{ fontSize: '16px', fontWeight: 'bold' }}
                          className={
                            balance < 0 ? 'amount-negative' : 'amount-positive'
                          }
                        >
                          Balance{': '}
                          {balance < 0
                            ? `- $${Math.abs(balance).toFixed(2)}`
                            : `$${balance.toFixed(2)}`}
                        </Typography>
                      </CardContent>
                    </div>
                  );
                })}
              </div>

              {this.renderSummaryTable()}

              {this.props.zelleHistory &&
                this.props.zelleHistory.length > 0 && (
                  <div className="zelle-history-card-container">
                    <div
                      style={{ marginTop: '24px' }}
                      className="note-card-zelle"
                    >
                      <CardContent>
                        <Typography
                          variant="subtitle2"
                          color="textSecondary"
                          style={{ fontWeight: '400' }}
                        >
                          Total Zelle Balance
                        </Typography>
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 'bold',
                            color: '#1976d2', // Blue accent
                            marginTop: 1,
                          }}
                        >
                          ${this.props.zelleTotalBalance.toLocaleString()}
                        </Typography>
                      </CardContent>
                    </div>
                  </div>
                )}
            </div>
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  loadingData: loadingSelector(state),
  employees: employeesSelector(state),
  zelleHistory: zelleHistorySelector(state),
  customers: customersSelector(state),
  zelleTotalBalance: zelleTotalBalanceSelector(state),
  allSessionIds: allSessionIdsSelector(state),
  zelleTable: zelleTableSelector(state),
});

const actionCreators = {
  getEmployees,
  saveZelleLoan,
  listZelleLoan,
  listAllCustomers,
  listSessionIds,
};

export default withShipment({ actionCreators, mapStateToProps }, ZelleReport);
